export default {
  state: () => ({
    data: {},
    points: {},
  }),
  mutations: {
    setStateDynamicModule(state, model) {
      state.data = model;
    },
  },
  namespaced: true,
};
